import { render } from "./InputText.vue?vue&type=template&id=096d28aa&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=096d28aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-096d28aa"

export default script